/* ==========================================================================
   Skogstad Sport – «Finn butikk»

   Seksjonen: sections/skogstad-finn-butikk.liquid
   Stilene:   assets/skogstad-finn-butikk.css

   Egen fil, ikke skogstad-globalt.js. Samme grunn som for CSS-en: dette er
   én side, og koden har ingenting å gjøre i en fil som lastes på hver
   sidevisning. Lastes med defer fra seksjonen selv.

   HELE FUNKSJONEN ER Å SETTE `hidden`
   Alle butikkene ligger i DOM-en fra server. Å filtrere er å sette og fjerne
   ett attributt per kort. Ingen nettverkskall, ingen ventetilstand, ingen
   spinner, ingen kappløp mellom to raske tastetrykk – og dermed heller ingen
   feiltilstand å håndtere. Samme prinsipp som målgruppefanene i Nyheter.

   INGEN DEBOUNCE
   Seksten kort med et attributt hver er under et millisekund. En debounce
   ville lagt 150 ms forsinkelse mellom tastetrykket og resultatet for å spare
   arbeid som ikke koster noe, og gjort feltet merkbart tregere enn det er.
   Blir det hundre butikker med tunge kort, er dette stedet å se på – ikke før.

   LYTTERNE ER DELEGERT FRA document
   Temaeditoren bygger seksjonen på nytt ved hver endring i innstillingene, og
   lyttere på enkeltnoder ville dødd med markupen de satt på. Delegering betyr
   at søket virker i editoren uten at noe må kjøres på nytt.
   ========================================================================== */
(function () {
  'use strict';

  var SEKSJON = '[data-skogstad-butikker]';
  var FELT = '[data-butikk-sok]';
  var KORT = '[data-butikk]';
  var TOMKNAPP = '[data-butikk-tom]';
  var INGEN = '[data-butikk-ingen]';
  var STATUS = '[data-butikk-status]';

  /* ------------------------------------------------------------------------
     Folding av søketekst

     «Orsta» skal finne Skogstad Ørsta, «Forde» skal finne Førde, og «LOM»
     skal finne Lom. Kunden som leter etter butikken sin skal ikke måtte
     finne Ø-tasten først – og på et utenlandsk tastatur er den kanskje ikke
     der i det hele tatt.

     Æ → ae og ikke → a. «Bærum» skrives «Baerum» av folk uten æ på
     tastaturet, ikke «Barum», og postadresser har brukt den skrivemåten i
     hundre år. Ø → o og å → a følger samme praksis.

     Foldinga kjøres på BEGGE sider av sammenligninga: både på det kunden
     skriver og på butikkens navn og adresse. Bare én side hadde gjort søket
     asymmetrisk – «Ørsta» ville ikke funnet seg selv.

     Rekkefølgen betyr noe: æ/ø/å erstattes FØR normalize('NFD'), som ellers
     ikke rører dem (de er egne bokstaver i Unicode, ikke a og o med tegn
     over). NFD + fjerning av kombinerende tegn tar seg av resten – é, ü, ä,
     ö – slik at «Møre» og «Moere» begge finner Ørsta og Nordfjordeid.

     `String.prototype.normalize` finnes i alle nettlesere Impulse støtter.
     Skulle den mangle, faller vi tilbake til bare æ/ø/å-erstatningene, som
     er de eneste som betyr noe for norske butikknavn.
     ------------------------------------------------------------------------ */
  function fold(tekst) {
    var t = String(tekst || '')
      .toLowerCase()
      .replace(/æ/g, 'ae')
      .replace(/ø/g, 'o')
      .replace(/å/g, 'a');

    if (typeof t.normalize === 'function') {
      t = t.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    /* Bindestrek, komma og punktum til mellomrom: «Arnulf Øverlands gate 2,
       6509 Kristiansund» skal treffes av «kristiansund» uten at kommaet
       henger fast i ordet foran. Deretter kollapses mellomrom, slik at
       «  gol  » og «gol» er samme søk. */
    return t.replace(/[.,\-/]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  /* ------------------------------------------------------------------------
     Filtrering

     ALLE ORDENE MÅ TREFFE, HVER FOR SEG
     Søket splittes på mellomrom og hvert ord må finnes et sted i teksten –
     ikke nødvendigvis i samme rekkefølge. «gol sentrumsvegen» og
     «sentrumsvegen gol» gir samme treff, og «2000 lillestrom» finner
     butikken selv om postnummeret står etter navnet i indeksen.

     Alternativet – å lete etter hele søkestrengen som én delstreng – ville
     gjort at «lillestrom torvet» ikke fant noe, fordi ordene står i motsatt
     rekkefølge i adressen. Kunden skriver det hun husker, i den rekkefølgen
     hun husker det.

     Søkeindeksen er bygget i Liquid (data-butikk-tekst) og inneholder navn og
     adresse samlet. Den foldes én gang per kort og bufres på noden – ellers
     ville seksten strenger blitt normalisert på nytt ved hvert tastetrykk.
     ------------------------------------------------------------------------ */
  function kortTekst(kort) {
    if (!kort.__fbTekst) {
      kort.__fbTekst = fold(kort.getAttribute('data-butikk-tekst') || kort.textContent);
    }
    return kort.__fbTekst;
  }

  function treffer(kort, ord) {
    var tekst = kortTekst(kort);
    for (var i = 0; i < ord.length; i++) {
      if (tekst.indexOf(ord[i]) === -1) return false;
    }
    return true;
  }

  function filtrer(seksjon) {
    var felt = seksjon.querySelector(FELT);
    if (!felt) return;

    var kort = Array.prototype.slice.call(seksjon.querySelectorAll(KORT));
    if (!kort.length) return;

    var sok = fold(felt.value);
    var ord = sok ? sok.split(' ') : [];
    var antall = 0;

    for (var i = 0; i < kort.length; i++) {
      var vis = ord.length === 0 || treffer(kort[i], ord);
      /* `hidden` og ikke en klasse: det er attributtet som faktisk fjerner
         elementet fra tilgjengelighetstreet, slik at skjermleseren ikke leser
         opp butikker kunden har filtrert bort. En klasse med display: none
         gjør det samme visuelt, men er lettere å miste synk med. */
      if (vis) {
        kort[i].removeAttribute('hidden');
        antall++;
      } else {
        kort[i].setAttribute('hidden', '');
      }
    }

    var ingen = seksjon.querySelector(INGEN);
    if (ingen) {
      if (antall === 0) ingen.removeAttribute('hidden');
      else ingen.setAttribute('hidden', '');
    }

    var tomknapp = seksjon.querySelector(TOMKNAPP);
    if (tomknapp) {
      if (felt.value) tomknapp.removeAttribute('hidden');
      else tomknapp.setAttribute('hidden', '');
    }

    /* Treffteller for skjermlesere. Står søket tomt, tømmes den – da er
       lista ufiltrert, og «16 butikker» er en opplesing ingen har bedt om.

       Strengene bor i markupen (data-en-treff / data-flere-treff på
       status-elementet), ikke her: all norsk tekst skal komme fra
       locales/nb.json via Liquid, aldri hardkodes i JavaScript.

       Plassholderen er «%n%» og ikke «{{ antall }}» – samme mønster som
       skogstad.antrekk.valgt_en. Shopifys t-filter tolker {{ }} selv, og hva
       det gjør med en plassholder som ikke er fylt ut er ikke dokumentert.
       %n% går uendret gjennom filteret. */
    var status = seksjon.querySelector(STATUS);
    if (status) {
      if (ord.length === 0) {
        status.textContent = '';
      } else if (antall === 0) {
        /* Hele hjelpeteksten, ikke «0 butikker». Avsnittet som vises på
           skjermen ligger utenfor det levende området og annonseres aldri –
           uten dette ville hun fått vite at søket mislyktes, men ikke hva
           hun kan gjøre i stedet. */
        status.textContent = status.getAttribute('data-ingen-treff') || '';
      } else {
        var mal = antall === 1
          ? status.getAttribute('data-en-treff')
          : status.getAttribute('data-flere-treff');
        status.textContent = (mal || '').replace('%n%', antall);
      }
    }
  }

  /* ------------------------------------------------------------------------
     Hendelser

     `input` og ikke `keyup`: input fanger også innliming med mus, diktering,
     autofyll og nettleserens egen tømmekryss – alt som endrer verdien uten
     at en tast ble sluppet.

     `search` i tillegg, for Safari: der utløser trykk på nettleserens egen
     tømmekryss `search`, ikke alltid `input`.
     ------------------------------------------------------------------------ */
  function seksjonenTil(node) {
    return node.closest ? node.closest(SEKSJON) : null;
  }

  document.addEventListener('input', function (evt) {
    if (!evt.target.matches || !evt.target.matches(FELT)) return;
    var seksjon = seksjonenTil(evt.target);
    if (seksjon) filtrer(seksjon);
  });

  document.addEventListener('search', function (evt) {
    if (!evt.target.matches || !evt.target.matches(FELT)) return;
    var seksjon = seksjonenTil(evt.target);
    if (seksjon) filtrer(seksjon);
  });

  document.addEventListener('click', function (evt) {
    var knapp = evt.target.closest ? evt.target.closest(TOMKNAPP) : null;
    if (!knapp) return;

    var seksjon = seksjonenTil(knapp);
    if (!seksjon) return;

    var felt = seksjon.querySelector(FELT);
    if (!felt) return;

    felt.value = '';
    filtrer(seksjon);
    /* Fokus tilbake i feltet. Knappen er nå skjult, og fokus på en skjult
       node faller til <body> – da har den som navigerer med tastatur mistet
       plassen sin og må tabbe fra toppen av siden igjen. */
    felt.focus();
  });

  /* Escape tømmer feltet. Konvensjonen for et søkefelt, og raskere enn å
     markere teksten og slette den. */
  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    if (!evt.target.matches || !evt.target.matches(FELT)) return;
    if (!evt.target.value) return;

    evt.target.value = '';
    var seksjon = seksjonenTil(evt.target);
    if (seksjon) filtrer(seksjon);
  });

  /* ------------------------------------------------------------------------
     Selvretting ved innlasting

     Nettleseren gjenoppretter verdien i søkefeltet når kunden kommer tilbake
     med tilbakeknappen, eller når hun laster siden på nytt. Uten dette ville
     feltet stått med «gol» og rutenettet vist alle seksten – en side som
     motsier seg selv.
     ------------------------------------------------------------------------ */
  function init() {
    var seksjoner = document.querySelectorAll(SEKSJON);
    for (var i = 0; i < seksjoner.length; i++) {
      var felt = seksjoner[i].querySelector(FELT);
      if (felt && felt.value) filtrer(seksjoner[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* bfcache: tilbakeknappen kan servere siden slik den sto, med en verdi i
     feltet som filtreringa allerede har svart på. Ingenting å gjøre da – men
     hadde nettleseren gjenopprettet verdien UTEN å gjenopprette
     `hidden`-attributtene, ville lista vært ufiltrert. Selvretting koster et
     enkelt kall. */
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) init();
  });

  /* Temaeditoren bytter ut hele seksjonen ved hver endring. Markupen kommer
     tilbake ufiltrert, men nettleseren kan ha beholdt verdien i feltet. */
  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target.querySelector && evt.target.querySelector(SEKSJON)) init();
  });

  /* ------------------------------------------------------------------------
     Blokkvalg i temaeditoren

     Å velge en butikk i sidepanelet rendrer IKKE seksjonen på nytt, så et
     aktivt søk står. Velger redaktøren en butikk som er filtrert bort, ruller
     editoren til et kort med `display: none` – hun ser ingenting skje, og har
     ingen måte å forstå hvorfor.

     Søket tømmes derfor ved blokkvalg. Det er den ene gangen filtreringa skal
     vike for noe annet: i editoren er lista et arbeidsverktøy, ikke et
     søkeresultat.
     ------------------------------------------------------------------------ */
  document.addEventListener('shopify:block:select', function (evt) {
    var seksjon = evt.target && evt.target.closest ? evt.target.closest(SEKSJON) : null;
    if (!seksjon) return;

    var felt = seksjon.querySelector(FELT);
    if (!felt || !felt.value) return;

    felt.value = '';
    filtrer(seksjon);
  });
})();
